if (!customElements.get('algolia-sort')) {
  class AlgoliaSort extends HTMLElement {
    constructor() {
      super();
      this.isOpen = false;
      this.init();
    };
    
    init() {
      const searchParams = new URLSearchParams(window.location.search);
      const initialIndex = searchParams.get('index') || false;
      const select = this.querySelector('[data-filter-action="algolia-sort"]');
      const toggleLabel = this.querySelector('[data-toggle-label]');
      
      if (initialIndex) {
        if (select) {
          select.value = initialIndex;
        }
        if (toggleLabel) toggleLabel.innerText = `SORT BY: ${select.options[select.options.selectedIndex].innerText}`;
      }
      
      this.addEventListener('click', (e) => {
        if (e.target.closest('input')) return;
        this.isOpen ? this.close() : this.open();
      })
      
      this.addEventListener('change', e => {
        if (select) {
          select.value = e.target.value;
          select.click();
        }
        if (toggleLabel) toggleLabel.innerText = `SORT BY: ${e.target.dataset.title}`;
        this.close();
      }); 
    }
    
    closeOutsideHandler = (e) => {
      if (!e.target.closest('algolia-sort')) {
        this.close();
        document.removeEventListener('click', this.closeOutsideHandler);
      }
    }
    
    open() {
      this.isOpen = true;
      this.insertAdjacentHTML('beforeend', this.renderDropdown());
      document.addEventListener('click', this.closeOutsideHandler);
    }
    
    close() {
      this.isOpen = false;
      this.querySelector('[data-dropdown]')?.remove();
    }
    
    renderDropdown() {
      const select = this.querySelector('[data-filter-action="algolia-sort"]');
      const options = [...select.options];
      return `
        <ul data-dropdown class="js-filter-list filter__list active">
          ${options.map(x => `
            <li class="filter__list-item">
              <label class="filter__tag visible" data-sort-filter="">
                <input 
                  class="filter__input js-sort-input" 
                  value="${x.value}" 
                  data-title="${x.innerText}" 
                  data-sort="${x.value}" 
                  name="sort" 
                  type="radio" 
                  data-tag="" 
                  data-algolia-filter=""
                  ${x.value === select.value ? `checked = true;` : ``}
                >
                <div class="filter__tag-wrapper">
                  <div class="filter__tag-heading">
                    ${x.innerText}
                  </div>

                  <div class="filter__radio" role="radio"></div>
                </div>
              </label>
            </li>
          `).join('')}
        </ul>
      `;
    }
  }
  customElements.define('algolia-sort', AlgoliaSort);
}